// The virtualized message list only mounts the rows near the viewport, so a
// loaded message further away has no DOM element for `scrollToMessage` to
// scroll into view. Each mounted list registers a scroller here that finds the
// message among its loaded messages and scrolls the virtualizer to it.
interface LoadedMessageScroller {
  hasMessage: (messageId: string) => boolean;
  scrollToMessage: (messageId: string, behavior: ScrollBehavior) => void;
}

const scrollers = new Set<LoadedMessageScroller>();

export const registerLoadedMessageScroller = (
  scroller: LoadedMessageScroller,
) => {
  scrollers.add(scroller);
  return () => {
    scrollers.delete(scroller);
  };
};

/** Whether a virtualized list has the message loaded, mounted or not. */
export const isMessageLoadedInVirtualizedList = (messageId: string) =>
  [...scrollers].some(scroller => scroller.hasMessage(messageId));

/**
 * Scrolls the virtualized list that has the message loaded to it. Returns
 * false when no list has it.
 */
export const scrollToLoadedMessage = (
  messageId: string,
  behavior: ScrollBehavior,
) => {
  const scroller = [...scrollers].find(({ hasMessage }) =>
    hasMessage(messageId),
  );
  scroller?.scrollToMessage(messageId, behavior);
  return Boolean(scroller);
};
